import Big from 'big.js'
import { Measure } from '../types'


enum FuelConsumptionMeasurementSystem {
  metric = 'Metric Units',
  usCustomary = 'US Customary Units',
  britishUnits = 'British Units'
}

const fuelConsumptionUnits = {
  liters_per_km: {
    displayName: 'Liters per km',
    codeName: 'liters_per_km',
    url: 'liters-per-km',
    symbol: 'L/km',
    toBaseUnit: (value: Big): Big => value,
    fromBaseUnit: (value: Big): Big => value,
    system: FuelConsumptionMeasurementSystem.metric
  },
  liters_per_10km: {
    displayName: 'Liters per 10 km',
    codeName: 'liters_per_10km',
    url: 'liters-per-10km',
    symbol: 'L/10km',
    toBaseUnit: (value: Big): Big => value.div(10),
    fromBaseUnit: (value: Big): Big => value.times(10),
    system: FuelConsumptionMeasurementSystem.metric
  },
  liters_per_100km: {
    displayName: 'Liters per 100 km',
    codeName: 'liters_per_100km',
    url: 'liters-per-100km',
    symbol: 'L/100km',
    toBaseUnit: (value: Big): Big => value.div(100),
    fromBaseUnit: (value: Big): Big => value.times(100),
    system: FuelConsumptionMeasurementSystem.metric
  },
  km_per_liter: {
    displayName: 'Kilometer per liter',
    codeName: 'km_per_liter',
    url: 'km-per-liter',
    symbol: 'km/L',
    toBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(1).div(value),
    fromBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(1).div(value),
    system: FuelConsumptionMeasurementSystem.metric
  },


  miles_per_gallon_us: {
    displayName: 'Miles per gallon (US)',
    codeName: 'miles_per_gallon_us',
    url: 'miles-per-gallon-us',
    symbol: 'mpg',
    toBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(2.3521458329).div(value),
    fromBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(2.3521458329).div(value),
    system: FuelConsumptionMeasurementSystem.usCustomary
  },
  miles_us_per_liter: {
    displayName: 'Miles (US) per liter',
    codeName: 'miles_us_per_liter',
    url: 'miles-us-per-liter',
    symbol: 'miles/L',
    toBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(0.6213711922).div(value),
    fromBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(0.6213711922).div(value),
    system: FuelConsumptionMeasurementSystem.usCustomary
  },
  gallons_per_100_miles_us: {
    displayName: 'Gallons per 100 miles (US)',
    codeName: 'gallons_per_100_miles_us',
    url: 'gallons-per-100-miles-us',
    symbol: 'gal/100mi (US)',
    toBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(1).div(value).times(42.5143707498),
    fromBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(1).div(value).times(42.5143707498),
    system: FuelConsumptionMeasurementSystem.usCustomary
  },

  miles_per_gallon_uk: {
    displayName: 'Miles per gallon (UK)',
    codeName: 'miles_per_gallon_uk',
    url: 'miles-per-gallon-uk',
    symbol: 'mpg',
    toBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(2.8248093628).div(value),
    fromBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(2.8248093628).div(value),
    system: FuelConsumptionMeasurementSystem.britishUnits
  },
  gallons_per_100_miles_uk: {
    displayName: 'Gallons per 100 miles (UK)',
    codeName: 'gallons_per_100_miles_uk',
    url: 'gallons-per-100-miles-uk',
    symbol: 'gal/100mi (UK)',
    toBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(1).div(value).times(35.4006189956),
    fromBaseUnit: (value: Big): Big => value.eq(0) ? new Big(0) : new Big(1).div(value).times(35.4006189956),
    system: FuelConsumptionMeasurementSystem.britishUnits
  }
}

export const fuelConsumption: Measure = {
  displayName: 'Fuel consumption',
  codeName: 'fuelConsumption',
  url: 'fuel-consumption',
  units: fuelConsumptionUnits,
  baseUnit: fuelConsumptionUnits.liters_per_km,
  defaultFromUnit: fuelConsumptionUnits.miles_per_gallon_us,
  defaultToUnit: fuelConsumptionUnits.liters_per_km
}
